// Selectors
import { ApplicationState } from '../../store';


export const supportSelector = (state: ApplicationState) => state.supportState


